// extracted by mini-css-extract-plugin
module.exports = {"actions":"Organizations_actions__1gv_w"};